/*
 * House of Daisy — saved pieces. The heart on cards and product pages.
 *
 * Signed in (window.hodCustomer): saved to her account through the House of
 * Daisy app (/apps/hod/saved). Anything she saved before signing in is moved
 * across once, then cleared from the device.
 * Signed out: kept on this device (localStorage), so the heart still works.
 * Her account page lists them, with "price has come down" and "sold out" from the app.
 */
(function () {
  var KEY = 'hod-saved';
  var signedIn = !!window.hodCustomer;
  var saved = new Set();

  function local() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setLocal(list) {
    try {
      if (list.length) localStorage.setItem(KEY, JSON.stringify(list));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function post(fields) {
    var body = new FormData();
    Object.keys(fields).forEach(function (k) {
      [].concat(fields[k]).forEach(function (v) {
        body.append(k, v);
      });
    });
    return fetch('/apps/hod/saved', { method: 'POST', body: body, headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function paint() {
    document.querySelectorAll('[data-hod-save]').forEach(function (b) {
      var on = saved.has(b.dataset.productId);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-saved', on);
      var label = b.querySelector('[data-hod-save-label]');
      if (label && window.hodSavedCopy) label.textContent = on ? window.hodSavedCopy.saved : window.hodSavedCopy.save;
    });
  }

  function toggle(b) {
    var id = b.dataset.productId;
    var on = !saved.has(id);
    if (on) saved.add(id);
    else saved.delete(id);
    paint();
    if (signedIn) {
      // Not kept (her session lapsed, the app unreachable): the heart goes back to what is true (a review, 2026-09-29).
      var undo = function () {
        if (on) saved.delete(id);
        else saved.add(id);
        paint();
      };
      post({ product_id: id, price: b.dataset.price, action: on ? 'add' : 'remove' }).then(
        function (d) {
          if (!d) undo();
        },
        undo
      );
    } else {
      var list = local().filter(function (x) {
        return x.id !== id;
      });
      if (on) {
        list.unshift({
          id: id,
          handle: b.dataset.handle,
          title: b.dataset.title,
          price: parseInt(b.dataset.price, 10) || null,
          image: b.dataset.image,
          at: Date.now()
        });
      }
      setLocal(list.slice(0, 60));
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hod-save]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b);
  });

  function load() {
    var pending = local();
    if (!signedIn) {
      pending.forEach(function (x) {
        saved.add(x.id);
      });
      paint();
      return Promise.resolve({ items: pending.map(function (x) { return { product_id: x.id, title: x.title, url: '/products/' + x.handle, image: x.image, price: x.price }; }), local: true });
    }
    var sync = pending.length
      ? post({
          action: 'sync',
          product_id: pending.map(function (x) { return x.id; }),
          price: pending.map(function (x) { return x.price || ''; })
        }).then(function (r) {
          if (r && r.ok) setLocal([]);
        })
      : Promise.resolve();
    return sync
      .then(function () {
        return fetch('/apps/hod/saved', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.ok ? r.json() : { items: [] };
      })
      .then(function (data) {
        (data.items || []).forEach(function (x) {
          saved.add(String(x.product_id));
        });
        paint();
        return data;
      })
      .catch(function () {
        return { items: [] };
      });
  }

  // Cards added later (filters, "load more") get painted too.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      paint();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.hodSaved = load();
})();
